import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { PublicProductAPI } from '../../../../services/PublicProductAPI';
import { useCart } from '../../../../context/CartContext';
import styles from './ProductView.module.css';
import ProductsCarousell from '../../../components/Carousell/products/ProductsCarousell';
import FeaturedProducts from '../../../components/Carousell/features/FeaturedProducts';
import logo from '../../../../logo.jpg'

function ProductView() {
    const { id } = useParams();
    const [product, setProduct] = useState(null);
    const [selectedSize, setSelectedSize] = useState('');
    const [mainImage, setMainImage] = useState('');
    const { addToCart, loading } = useCart();

    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

    useEffect(() => {
        const fetchProduct = async () => {
            try {
                const data = await PublicProductAPI.get_product_by_id(id);
                setProduct(data);
                // Define a imagem principal inicial (usa o campo image_url do to_dict)
                setMainImage(data.image_url);
            } catch (error) {
                console.error("Erro ao carregar produto:", error);
            }
        };
        fetchProduct();
    }, [id]);

    if (!product) return <div className={styles.loading}>Carregando...</div>;

    const sizes = product.options ? product.options.split(',') : [];

    // Galeria unificada: imagem principal + extras
    const galleryImages = [
        product.image_url,
        product.image1_url,
        product.image2_url,
        product.image3_url,
        product.image4_url,
        product.image5_url
    ].filter(img => img && img !== '' && !img.includes('None'));

    const handleAddToCart = () => {
        if (product.stock_quantity === 0) return;
        addToCart(product.id, selectedSize || 'Único');
    };

    return (
        <div className={styles.container}>
            <div className={styles.grid}>
                {/* Lado Esquerdo: Imagens */}
                <div className={styles.imageSection}>
                    <div className={styles.mainImageWrapper}>
                        <img
                            src={mainImage ? `${API_BASE_URL}${mainImage}` : `${API_BASE_URL}/static/uploads/products/default.jpg`}
                            alt={product.name}
                            className={styles.mainImage}
                        />
                    </div>

                    {galleryImages.length > 1 && (
                        <div className={styles.thumbnailGrid}>
                            {galleryImages.map((img, index) => (
                                <div
                                    key={index}
                                    className={`${styles.thumbWrapper} ${mainImage === img ? styles.activeThumb : ''}`}
                                    onClick={() => setMainImage(img)}
                                >
                                    <img src={`${API_BASE_URL}${img}`} alt={`Miniatura ${index}`} />
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* Lado Direito: Info */}
                <div className={styles.infoSection}>
                    <h1 className={styles.title}>{product.name}</h1>
                    <p className={styles.price}>R$ {(product.price || 0).toFixed(2)}</p>

                    <div className={styles.description}>
                        <h3>Descrição</h3>
                        <p>{product.description || "Sem descrição disponível."}</p>
                    </div>

                    {sizes.length > 0 && (
                        <div className={styles.sizeSelection}>
                            <span className={styles.label}>Opções disponíveis:</span>
                            <div className={styles.sizeGrid}>
                                {sizes.map(size => (
                                    <button
                                        key={size}
                                        className={`${styles.sizeBtn} ${selectedSize === size.trim() ? styles.active : ''}`}
                                        onClick={() => setSelectedSize(size.trim())}
                                    >
                                        {size.trim()}
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}

                    <button
                        className={styles.buyBtn}
                        onClick={handleAddToCart}
                        disabled={(sizes.length > 0 && !selectedSize) || loading}
                    >
                        {loading ? 'Processando...' : 'Adicionar ao Carrinho'}
                    </button>
                </div>
            </div>

            {/* Seção de Vídeo */}
            {product.video_url && (
                <div className={styles.videoSection}>
                    <div className={styles.videoHeader}>
                        <h2 className={styles.videoTitle}>Produto em Detalhes</h2>
                        <div className={styles.videoDivider}></div>
                    </div>

                    <div className={styles.videoContainer}>
                        <video
                            key={product.video_url} // Força o React a recarregar o player se o vídeo mudar
                            controls
                            className={styles.videoPlayer}
                            poster={logo}
                            preload="auto"
                        >
                            {/* Aqui está o pulo do gato: combine a URL base com a url do vídeo */}
                            <source src={`${API_BASE_URL}${product.video_url}`} type="video/mp4" />
                            Seu navegador não suporta a reprodução de vídeos.
                        </video>
                    </div>
                </div>
            )}
            <ProductsCarousell />
            <FeaturedProducts />
        </div>
    );
}

export default ProductView;